import { useShallow } from 'zustand/react/shallow';

import { useBoundStore } from '@/store/store';

export function useRouter() {
  const { pushRoute, popRoute, route, routeData } = useBoundStore(
    useShallow(state => ({
      pushRoute: state.pushRoute,
      popRoute: state.popRoute,
      route: state.route,
      routeData: state.routeData,
    })),
  );

  return {
    pushRoute,
    popRoute,
    route,
    routeData,
  };
}
